<template>
  <div class="container">
    <div class="quantity">
      <v-form-number
        name="quantity"
        :type="quantityType"
        class="quantity__input"
        :value="inputValue"
        ref="limitTriggerIp"
        @input="onInput"
        @keydown.native.tab="onTabNavigation"
        :step="increment"
        :max="params.originalValue"
        :min="0"
        :maximumFractionDigits="maximumFractionDigits"
      />
    </div>
  </div>
</template>

<script>
import { isNaN } from 'lodash-es';

export default {
  name: 'quantity-custom-editor',
  data() {
    return {
      inputValue: 0,
      disabledStyle: ' {color:#ffffff; background-color:none; border-color:none}',
      isValidInput: false,
      controlPressed: false,
      valuePasted: false
    };
  },
  methods: {
    getValue() {
      return this.inputValue;
    },
    onInput(value) {
      if (
        this.$store.state.applicationSettings.general.settings.applicationLanguage.substr(0, 2) === 'fr' &&
        typeof value === 'string'
      ) {
        value = value.replace(',', '.');
      }
      this.inputValue = isNaN(Number.parseFloat(value)) ? this.params.value : Number.parseFloat(value);
      if (this.params.colDef.field === 'quantity') {
        this.params.node.data.quantity = this.inputValue;
      } else this.params.node.data.extendedTerms.remainingQuantity = this.inputValue;
      this.params.context.triggerInlineEditChange(this.params, this.inputValue);
    },
    onTabNavigation(event) {
      this.params.api.stopEditing();
      if (event.shiftKey) this.params.api.tabToPreviousCell();
      else this.params.api.tabToNextCell();
    }
  },
  mounted() {
    this.inputValue = this.params.value || '';
  },
  computed: {
    increment() {
      let incrementVal = 1;
      if (this.params.data.security.type === 'EQUITY') {
        incrementVal = this.$store.state.applicationSettings.orders.settings.stocks.defaultOrderIncrement;
      } else if (this.params.data.security.type === 'OPTION') {
        incrementVal = this.$store.state.applicationSettings.orders.settings.options.defaultOrderIncrement;
      }
      return incrementVal;
    },
    disableDecrementer() {
      return this.inputValue < this.increment || this.inputValue === '';
    },
    isFractionalOrder() {
      return this.params.data.value % 1 != 0;
    },
    isNotional() {
      return !!this.params.data.dollarAmt;
    },
    maximumFractionDigits() {
      return this.isNotional ? 2 : 5;
    },
    quantityType() {
      return this.params.isFractionalTradingAllowed ? 'float' : 'integer';
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 67px;
  position: relative;
  bottom: 2.2px;
}
.quantity {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.quantity__input {
  width: calc-em(120px);
  height: calc-em(23px);
  margin: 0;
  padding: 0;
  text-align: center;
  color: $input-color;
  background: $input-bg;
  background-clip: padding-box;
  border: $input-border-width solid $input-border-color;
  border-radius: 0;
  align-items: center;
}
</style>
